import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'syr-header',
  templateUrl: './header-nav-bar.component.html',
  styleUrls: ['./header-nav-bar.component.scss']
})
export class HeaderNavBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
